var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#e0225c" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.047 6.443C28.773 6.463.059 32.646.03 64.803c3.523 2.397 5.611 3.476 8.41 4.648 5.73-3.558 12.371-5.441 19.204-5.441 2.039 0 4.097.172 6.117.508 6.37 1.054 17.527 6.972 22.152 10.921a40.191 40.191 0 013.777-6.168c.602-.8 1.239-1.582 1.903-2.343-5.824-4.485-18.266-10.79-25.903-12.055a49.266 49.266 0 00-8.058-.664c-5.524-.008-11 .93-16.145 2.762 4.18-23.332 26.422-40.707 52.606-40.727 14.195 0 27.535 5.035 37.566 14.176 8.008 7.293 13.125 16.414 14.895 26.473-5.164-1.836-10.606-2.778-16.2-2.797l-.785-.004a47.641 47.641 0 00-4.61.277c-.284.027-.57.07-.85.106-.692.086-1.376.18-2.055.293-.305.046-.602.101-.903.156-.687.129-1.375.273-2.054.43-.246.054-.493.109-.735.167-.855.211-1.707.446-2.547.704-.05.015-.101.027-.152.043a46.471 46.471 0 00-5.527 2.117 5.032 5.032 0 01-.145.07c-.832.383-1.652.793-2.457 1.23l-.2.106c-4.241 2.32-8.01 5.285-11.147 8.773l-.391.434c-.688.785-1.36 1.59-1.988 2.43a42.558 42.558 0 00-1.836 2.695 38.383 38.383 0 00-1.313 2.234 38.49 38.49 0 00-2.32 5.133v.008a36.862 36.862 0 00-2.254 13.352c.004.18.004.363.008.543.011.355.031.71.054 1.066.036.582.082 1.164.145 1.746.039.363.086.73.137 1.098.03.23.058.465.097.699.094.61.203 1.219.328 1.824 1.554 7.488 5.388 14.235 10.913 19.73 2.01-3.037 2.12-3.672 4.155-9.445-4.934-5.325-5.048-10.33-5.048-17.73 0-16.102 13.809-29.473 31.434-30.442l1.113-.039c7.144-.164 14.183 1.758 20.16 5.465l4.018-2.6 4.388-2.029c.012-15.586-6.636-30.234-18.722-41.246C97.203 12.498 81.16 6.443 64.046 6.443z"
  }));
};